import { Link } from "react-router-dom";
import { MdLocationPin } from "react-icons/md";
import { PiCurrencyInr } from "react-icons/pi";
import { Skeleton, Space } from "antd";

export default function VendorCard({
  cover_image,
  name,
  based_area,
  city,
  pricing,
  slug,
  loading,
}) {
  return loading ? (
    <Space className="venues-section-2-main-card-con" direction="vertical">
      <Skeleton.Image active={true} style={{ width: 350, height: 250 }} />
      <Skeleton.Node active={true} style={{ width: 350, height: 15 }} />
      <Skeleton.Node active={true} style={{ width: 350, height: 15 }} />
    </Space>
  ) : (
    <div className="venues-section-2-main-card-con">
      <Link to={`/details/${slug}`}>
        <div className="venues-section-2-main-image-con">
          <div className="venues-section-2-image-con">
            <img
              src={
                cover_image ||
                "https://find-company-online.co.uk/uploads/images/no-thumb.png"
              }
              alt={name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "10px",
              }}
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop
                e.target.src =
                  "https://find-company-online.co.uk/uploads/images/no-thumb.png";
              }}
            />
          </div>
        </div>

        <div className="venues-section-2-main-card-details-con">
          <h4>{name}</h4>
          <div className="venues-section-2-card-location-and-category">
            <div className="venues-section-2-card-location">
              <MdLocationPin />
              <p>
                <span>{based_area},</span>
                <span>{city}</span>
              </p>
            </div>
          </div>
          <div className="venues-section-2-card-food-details-main-con">
            {pricing?.map((elem) => {
              return (
                <>
                  <div className="venues-section-2-card-food-details-con">
                    <h6>Starting Price</h6>
                    <p>
                      <PiCurrencyInr /> {elem.price}{" "}
                      <span>{elem.price_name}</span>
                    </p>
                  </div>
                </>
              );
            })}
          </div>

        </div>
      </Link>
    </div>
  );
}
